import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

export interface SignerRow {
  signer_name: string;
  signer_email: string;
  status: string;
  order_index: number;
  signed_at: string | null;
}

interface SignersCardProps {
  title: string;
  signers: SignerRow[];
  currentEmail: string;
}

export function SignersCard({ title, signers, currentEmail }: SignersCardProps) {
  return (
    <div className="rounded-[18px] border border-border bg-card px-7 py-6 shadow-card">
      <h2 className="mb-4 text-[15px] font-bold text-foreground">{title}</h2>
      {signers.map((s, i) => {
        const isMe = s.signer_email.toLowerCase() === currentEmail.toLowerCase();
        const role = s.order_index === 0 ? "Contratada" : "Contratante";
        const signed = s.status === "signed";
        const rejected = s.status === "rejected";
        const when =
          signed && s.signed_at
            ? format(new Date(s.signed_at), "dd/MM · HH:mm", { locale: ptBR })
            : rejected
              ? "rejeitou"
              : "aguardando";
        return (
          <div
            key={i}
            className="flex items-center gap-[13px] border-b border-border/60 py-[11px] last:border-0"
          >
            <span
              className={`flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full text-[11px] font-bold ${
                signed
                  ? "bg-ok text-ok-foreground"
                  : rejected
                    ? "bg-bad text-bad-foreground"
                    : "bg-muted text-muted-foreground"
              }`}
            >
              {signed ? "✓" : rejected ? "×" : ""}
            </span>
            <div className="min-w-0 flex-1">
              <div className="truncate text-[13px] font-semibold text-foreground">
                {s.signer_name}
              </div>
              <div className="text-[11.5px] text-muted-foreground">
                {role}
                {isMe ? " · você" : signed ? " · assinatura digital" : ""}
              </div>
            </div>
            <span className="text-[11.5px] text-muted-foreground">{when}</span>
          </div>
        );
      })}
    </div>
  );
}
